import { AuthProvider } from './contexts/AuthContext';
import { AdminProvider } from './contexts/AdminContext';
import { WalletProvider } from './contexts/WalletContext';
import { TransferProvider } from './contexts/TransferContext';
import { DevLogProvider } from './contexts/DevLogContext';
import MainLayout from './components/layout/MainLayout';
import DevLogButton from './components/dev/DevLogButton';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import { logQRLinkOpened, logAppError } from './services/loggingService';

function App() {
  // Log imediato quando a página carrega com link para receber (QR)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('pay') === '1') {
      logQRLinkOpened({
        to: params.get('to') ? 'present' : 'missing',
        amount: params.get('amount') || 'missing',
        token: params.get('token') || 'missing',
        network: params.get('network') || 'missing',
        currency: params.get('currency') || 'missing',
      });
    }
  }, []);

  useEffect(() => {
    const handleError = (event) => {
      console.error('Erro não tratado:', event.error);
      logAppError(
        event.error?.message ?? String(event.message),
        event.error?.stack ?? event.error?.stack
      );
    };

    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  return (
    <DevLogProvider>
      <AuthProvider>
        <AdminProvider>
          <WalletProvider>
            <TransferProvider>
              <MainLayout />
              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#1f2937',
                    color: '#fff',
                    border: '1px solid #4c1d95',
                  },
                }}
              />
              <DevLogButton />
            </TransferProvider>
          </WalletProvider>
        </AdminProvider>
      </AuthProvider>
    </DevLogProvider>
  );
}

export default App;
